import api from "@/api/viktor"

export async function getMe() {
  const response = await api({
    method: "get",
    url: "/me",
  })

  return response
}

export async function patchConsent(user_uuid: string) {
  const response = await api({
    method: "PATCH",
    url: `/user/${user_uuid}/consent`,
    data: {
      tou: 1,
    },
  })
  return response
}
